'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerLogin = function CustomerLogin() {
  (0, _classCallCheck3.default)(this, CustomerLogin);

  function accountForgotPassword() {
    function showRecoverPasswordForm() {
      (0, _jquery2.default)('#RecoverPasswordForm').show();
      (0, _jquery2.default)('#CustomerLoginForm').hide();
    }

    function hideRecoverPasswordForm() {
      (0, _jquery2.default)('#RecoverPasswordForm').hide();
      (0, _jquery2.default)('#CustomerLoginForm').show();
    }

    (0, _jquery2.default)('#RecoverPassword').on('click', function (e) {
      e.preventDefault();
      showRecoverPasswordForm();
    });

    (0, _jquery2.default)('#HideRecoverPasswordLink').on('click', function (e) {
      e.preventDefault();
      hideRecoverPasswordForm();
    });

    if (window.location.hash.indexOf('recover') !== -1) {
      showRecoverPasswordForm();
    }
  }

  accountForgotPassword();
}; /**
    * Password Template Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Password template.
    *
    * @namespace password
    */

exports.default = CustomerLogin;